import { SwaggerConfig } from './swagger.interface';

/**
 * Configuration for the swagger UI (found at /api).
 * Change this to suit your app!
 */
export const SWAGGER_CONFIG: SwaggerConfig = {
  title: 'Finest Choicex - IAM',
  description: 'Services for Identity and Access Management',
  version: '1.0',
  tags: ['IAM'],
};
